// #583 S6a — the console's own theme preference. index.html applies it before first paint; this
// module owns every change after that. It never touches the family app's settings or its key.
export const THEME_KEY = 'chorestory.platform.theme';
export const DARK_QUERY = '(prefers-color-scheme: dark)';
// The browser chrome colour: --surface-1 in each theme (pinned by styles/ledger-tokens.test.js).
const THEME_COLOR = { light: '#fffcf6', dark: '#25272c' };

export function themePreference() {
  try {
    const saved = localStorage.getItem(THEME_KEY);
    return saved === 'light' || saved === 'dark' ? saved : 'system';
  } catch {
    return 'system';
  }
}

/** Put the resolved theme on <html>. Colours only: nothing else reads data-theme. */
export function applyTheme(preference) {
  const mode = preference === 'system'
    ? (window.matchMedia?.(DARK_QUERY).matches ? 'dark' : 'light')
    : preference;
  document.documentElement.dataset.theme = mode;
  document.documentElement.style.colorScheme = mode;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.content = THEME_COLOR[mode];
}

export function setThemePreference(preference) {
  try {
    if (preference === 'system') localStorage.removeItem(THEME_KEY);
    else localStorage.setItem(THEME_KEY, preference);
  } catch {
    // Storage refused (private mode): the choice still applies to this page.
  }
  applyTheme(preference);
}
